import React from 'react';
import classnames from 'classnames';

/** Breakpoint below which the toggle is visible.
 * 'medium' = $msv-breakpoint-m (768px),
 * 'small' = $msv-breakpoint-ssm (480px).
 * */
export type ColumnToggleShowAtBreakpoint = 'medium' | 'small';
export type ColumnCount = 1 | 2;

interface ColumnToggleProps {
    singleColumnViewAriaLabel: string;
    twoColumnViewAriaLabel: string;
    columns: ColumnCount;
    onChange: (columns: ColumnCount) => void;
    showAtBreakPoint?: ColumnToggleShowAtBreakpoint;
}

export const ColumnToggle = ({
    singleColumnViewAriaLabel,
    twoColumnViewAriaLabel,
    columns,
    onChange,
    showAtBreakPoint = 'medium'
}: ColumnToggleProps) => (
    <div className={classnames('bs-column-toggle', { 'bs-column-toggle--visible-below-small': showAtBreakPoint === 'small' })}>
        <button
            type='button'
            className={classnames('bs-column-toggle__btn', { 'bs-column-toggle__btn--active': columns === 1 })}
            onClick={() => onChange(1)}
            aria-label={singleColumnViewAriaLabel}
            aria-pressed={columns === 1}
        >
            <span className='bs-column-toggle__icon bs-column-toggle__icon--single' aria-hidden='true' />
        </button>
        <button
            type='button'
            className={classnames('bs-column-toggle__btn', { 'bs-column-toggle__btn--active': columns === 2 })}
            onClick={() => onChange(2)}
            aria-label={twoColumnViewAriaLabel}
            aria-pressed={columns === 2}
        >
            <span className='bs-column-toggle__icon bs-column-toggle__icon--grid' aria-hidden='true' />
        </button>
    </div>
);
